import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { queryKeys } from "@/constants/queryKeys";
import { useCustomerScopedQuery } from "@/hooks/useCustomerScopedQuery";
import { services } from "@/services/registry";
export const useContracts = (productCode, enabled = true)=>{
    return useCustomerScopedQuery({
        queryKey: queryKeys.contracts.list(productCode),
        queryFn: ({ customerId })=>services.contractsService.getContractsByCustomer(productCode, customerId),
        staleTime: 5 * 60 * 1000,
        enabled
    });
};
/**
 * Hook to get the first available contract ID for usage queries
 * This is a temporary solution until we have proper contract selection UI
 */ export const useDefaultContractId = (productCode)=>{
    const { data: contractsData, isLoading, error } = useContracts(productCode);
    const contractId = contractsData?.contracts?.[0]?.contract?.ContractId || null;
    return {
        contractId,
        isLoading,
        error,
        hasContracts: !!contractsData?.contracts?.length,
        contractDetails: contractsData?.contracts?.[0]
    };
};
export const usePricingPolicies = ()=>{
    return useQuery({
        queryKey: queryKeys.contracts.pricingPolicies(),
        queryFn: ()=>services.contractsService.getAllPricingPolicies(),
        staleTime: 10 * 60 * 1000
    });
};
export const useCreateContract = ()=>{
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (data)=>services.contractsService.createContract(data),
        onSuccess: ()=>{
            // Invalidate contracts queries to refetch
            queryClient.invalidateQueries({
                queryKey: queryKeys.contracts.list()
            });
        }
    });
};
export const useReissueResolveToken = ()=>{
    return useMutation({
        mutationFn: ({ contractId, resolveTokenExpiryHours = 24 })=>services.contractsService.reissueResolveToken(contractId, resolveTokenExpiryHours)
    });
};
